import axios from "axios"
import { encrypt } from '../utils/encryption';


// Create API instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    async (config) => {
        try {
            // Get fresh token
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            // Add service authentication
            const encryptedService = encrypt(process.env.REACT_APP_SERVICE_NAME);
            const encryptedKey = encrypt(process.env.REACT_APP_SERVICE_KEY);

            // Handle media requests differently
            if (config.url.includes('/image/') || config.url.includes('/stream-audio/')) {
                // For media requests, use query params
                const fullUrl = new URL(config.url, process.env.REACT_APP_API_URL);
                fullUrl.searchParams.set('x-service-name', encryptedService);
                fullUrl.searchParams.set('x-service-key', encryptedKey);
                config.url = fullUrl.toString();
            } else {
                // For API requests, use headers
                config.headers['x-service-name'] = encryptedService;
                config.headers['x-service-key'] = encryptedKey;
            }

            return config;
        } catch (error) {
            console.error('Request interceptor error:', error);
            return Promise.reject(error);
        }
    },
    (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error.config;
        config.retryCount = config.retryCount || 0;

        if ((error.response?.status === 401 || error.response?.status === 403) && config.retryCount < 2) {
            config.retryCount += 1;
            console.log(`Retry attempt ${config.retryCount} for ${config.url}`);

            try {
                const { fetchAuth } = await import('../utils/auth');
                await fetchAuth();
                const token = localStorage.getItem('token');
                
                if (!token) {
                    throw new Error('Token refresh failed');
                }

                // Preserve all headers while updating auth token
                config.headers['Authorization'] = `Bearer ${token}`;
                return axiosInstance(config);
            } catch (refreshError) {
                console.error('Auth refresh failed:', refreshError);
                if (config.retryCount >= 2) {
                    window.location.href = '/login';
                }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export { axiosInstance as API };